import React from 'react';
import { Link } from 'react-router-dom';

const Home = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative overflow-hidden bg-gradient-to-r from-blue-600 via-purple-600 to-blue-800">
        <div className="absolute inset-0 bg-black opacity-20"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24">
          <div className="text-center">
            <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 animate-fade-in">
              Roadmap Digitalisasi
              <span className="block text-yellow-300">Al Wafi Islamic Boarding School</span>
            </h1>
            <p className="text-xl md:text-2xl text-blue-100 mb-8 max-w-3xl mx-auto animate-slide-up">
              Transformasi Digital Menuju Pendidikan Islam Modern dan Terintegrasi
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center animate-bounce-in">
              <Link
                to="/timeline"
                className="bg-white text-blue-600 px-8 py-4 rounded-full font-semibold text-lg hover:bg-blue-50 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
              >
                <i className="fas fa-calendar-alt mr-2"></i>
                Lihat Timeline
              </Link>
              <Link
                to="/overview"
                className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white hover:text-blue-600 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
              >
                <i className="fas fa-chart-line mr-2"></i>
                Overview Program
              </Link>
            </div>
          </div>
        </div>
        
        {/* Floating Elements */}
        <div className="absolute top-20 left-10 w-20 h-20 bg-yellow-300 rounded-full opacity-20 animate-bounce"></div>
        <div className="absolute bottom-20 right-10 w-16 h-16 bg-blue-300 rounded-full opacity-20 animate-bounce" style={{animationDelay: '1s'}}></div>
        <div className="absolute top-1/2 left-1/4 w-12 h-12 bg-purple-300 rounded-full opacity-20 animate-bounce" style={{animationDelay: '2s'}}></div>
      </section>

      {/* Quick Stats */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="text-center p-6 bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-calendar-alt text-white text-2xl"></i>
              </div>
              <h3 className="text-3xl font-bold text-blue-600 mb-2">11</h3>
              <p className="text-gray-600 font-medium">Bulan Program</p>
            </div>
            
            <div className="text-center p-6 bg-gradient-to-br from-green-50 to-green-100 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-tasks text-white text-2xl"></i>
              </div>
              <h3 className="text-3xl font-bold text-green-600 mb-2">50+</h3>
              <p className="text-gray-600 font-medium">Aktivitas Utama</p>
            </div>
            
            <div className="text-center p-6 bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-users text-white text-2xl"></i>
              </div>
              <h3 className="text-3xl font-bold text-purple-600 mb-2">5</h3>
              <p className="text-gray-600 font-medium">Program Utama</p>
            </div>
            
            <div className="text-center p-6 bg-gradient-to-br from-orange-50 to-orange-100 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="fas fa-tablet-alt text-white text-2xl"></i>
              </div>
              <h3 className="text-3xl font-bold text-orange-600 mb-2">100%</h3>
              <p className="text-gray-600 font-medium">Digital Integration</p>
            </div>
          </div>
        </div>
      </section>

      {/* Key Features */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Fitur Utama Program
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Program digitalisasi yang komprehensif untuk transformasi pendidikan Islam modern
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-600 rounded-lg flex items-center justify-center mb-6">
                <i className="fas fa-tablet-alt text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">iPad Integration</h3>
              <p className="text-gray-600 leading-relaxed">
                Setiap santri dan guru mendapat iPad dengan sistem MDM yang terkontrol untuk pembelajaran digital yang aman dan terarah.
              </p>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-r from-green-500 to-teal-600 rounded-lg flex items-center justify-center mb-6">
                <i className="fas fa-graduation-cap text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">LMS Platform</h3>
              <p className="text-gray-600 leading-relaxed">
                Learning Management System terintegrasi untuk pembelajaran, penilaian, dan komunikasi antara guru, santri, dan wali santri.
              </p>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
              <div className="w-16 h-16 bg-gradient-to-r from-orange-500 to-red-600 rounded-lg flex items-center justify-center mb-6">
                <i className="fas fa-chart-line text-white text-2xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Real-time Monitoring</h3>
              <p className="text-gray-600 leading-relaxed">
                Sistem monitoring real-time untuk aktivitas akademik, ibadah, dan kehidupan asrama yang dapat dipantau wali santri.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Quick Access Menu */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold text-gray-800 mb-4">Menu Cepat</h2>
            <p className="text-gray-600 max-w-2xl mx-auto">Akses langsung ke semua informasi penting tentang roadmap digitalisasi Al Wafi</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {/* Timeline */}
            <Link to="/timeline" className="group bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden border border-gray-100">
              <div className="h-2 bg-gradient-to-r from-blue-500 to-blue-600"></div>
              <div className="p-6">
                <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="fas fa-calendar-alt text-white text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-blue-600 transition-colors">Timeline</h3>
                <p className="text-gray-600 text-sm mb-4">Jadwal lengkap implementasi digitalisasi dari Agustus 2025 hingga Juli 2026 dengan milestone penting</p>
                <div className="flex items-center text-blue-600 text-sm font-medium">
                  <span>Lihat Timeline</span>
                  <i className="fas fa-arrow-right ml-2 group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>

            {/* Overview */}
            <Link to="/overview" className="group bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden border border-gray-100">
              <div className="h-2 bg-gradient-to-r from-green-500 to-green-600"></div>
              <div className="p-6">
                <div className="w-12 h-12 bg-gradient-to-r from-green-500 to-green-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="fas fa-chart-line text-white text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-green-600 transition-colors">Overview Program</h3>
                <p className="text-gray-600 text-sm mb-4">Gambaran menyeluruh struktur program, fase implementasi, dan target pencapaian digitalisasi</p>
                <div className="flex items-center text-green-600 text-sm font-medium">
                  <span>Lihat Overview</span>
                  <i className="fas fa-arrow-right ml-2 group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>

            {/* Manfaat Program */}
            <Link to="/benefits" className="group bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden border border-gray-100">
              <div className="h-2 bg-gradient-to-r from-purple-500 to-purple-600"></div>
              <div className="p-6">
                <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-purple-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="fas fa-star text-white text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-purple-600 transition-colors">Manfaat Program</h3>
                <p className="text-gray-600 text-sm mb-4">Keuntungan dan dampak positif digitalisasi untuk santri, guru, dan wali santri</p>
                <div className="flex items-center text-purple-600 text-sm font-medium">
                  <span>Lihat Manfaat</span>
                  <i className="fas fa-arrow-right ml-2 group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>

            {/* Manfaat iPad */}
            <Link to="/ipad-benefits" className="group bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden border border-gray-100">
              <div className="h-2 bg-gradient-to-r from-orange-500 to-orange-600"></div>
              <div className="p-6">
                <div className="w-12 h-12 bg-gradient-to-r from-orange-500 to-orange-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="fas fa-tablet-alt text-white text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-orange-600 transition-colors">Manfaat iPad</h3>
                <p className="text-gray-600 text-sm mb-4">15 manfaat spesifik penggunaan iPad untuk pendidikan, pengasuhan, dan sistem terintegrasi</p>
                <div className="flex items-center text-orange-600 text-sm font-medium">
                  <span>Lihat Manfaat iPad</span>
                  <i className="fas fa-arrow-right ml-2 group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>

            {/* iPad: Lebih dari Buku */}
            <Link to="/ipad-beyond-books" className="group bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden border border-gray-100">
              <div className="h-2 bg-gradient-to-r from-yellow-500 to-yellow-600"></div>
              <div className="p-6">
                <div className="w-12 h-12 bg-gradient-to-r from-yellow-500 to-yellow-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="fas fa-rocket text-white text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-yellow-600 transition-colors">iPad: Lebih dari Buku</h3>
                <p className="text-gray-600 text-sm mb-4">Mengapa iPad adalah revolusi pembelajaran, bukan sekadar pengganti buku digital</p>
                <div className="flex items-center text-yellow-600 text-sm font-medium">
                  <span>Pelajari Revolusi iPad</span>
                  <i className="fas fa-arrow-right ml-2 group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>

            {/* Apa itu MDM */}
            <Link to="/mdm-explained" className="group bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden border border-gray-100">
              <div className="h-2 bg-gradient-to-r from-cyan-500 to-cyan-600"></div>
              <div className="p-6">
                <div className="w-12 h-12 bg-gradient-to-r from-cyan-500 to-cyan-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="fas fa-mobile-alt text-white text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-cyan-600 transition-colors">Apa itu MDM?</h3>
                <p className="text-gray-600 text-sm mb-4">Penjelasan lengkap Mobile Device Management dengan contoh mudah dipahami untuk pendidikan</p>
                <div className="flex items-center text-cyan-600 text-sm font-medium">
                  <span>Pelajari MDM</span>
                  <i className="fas fa-arrow-right ml-2 group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>

            {/* Checklist Pengasuhan */}
            <Link to="/pengasuhan-checklist" className="group bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden border border-gray-100">
              <div className="h-2 bg-gradient-to-r from-teal-500 to-teal-600"></div>
              <div className="p-6">
                <div className="w-12 h-12 bg-gradient-to-r from-teal-500 to-teal-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="fas fa-clipboard-check text-white text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-teal-600 transition-colors">Checklist Pengasuhan</h3>
                <p className="text-gray-600 text-sm mb-4">Panduan lengkap tugas tim pengasuhan per bulan dengan tujuan dan output yang jelas</p>
                <div className="flex items-center text-teal-600 text-sm font-medium">
                  <span>Lihat Checklist</span>
                  <i className="fas fa-arrow-right ml-2 group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>

            {/* Tahapan Implementasi */}
            <Link to="/implementation-phases" className="group bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden border border-gray-100">
              <div className="h-2 bg-gradient-to-r from-indigo-500 to-indigo-600"></div>
              <div className="p-6">
                <div className="w-12 h-12 bg-gradient-to-r from-indigo-500 to-indigo-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="fas fa-project-diagram text-white text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-indigo-600 transition-colors">Tahapan Implementasi</h3>
                <p className="text-gray-600 text-sm mb-4">8 tahapan detail dari perencanaan hingga go-live dengan aktivitas dan deliverables</p>
                <div className="flex items-center text-indigo-600 text-sm font-medium">
                  <span>Lihat Tahapan</span>
                  <i className="fas fa-arrow-right ml-2 group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>

            {/* What-Why-How */}
            <Link to="/roadmap-what-why-how" className="group bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden border border-gray-100">
              <div className="h-2 bg-gradient-to-r from-pink-500 to-pink-600"></div>
              <div className="p-6">
                <div className="w-12 h-12 bg-gradient-to-r from-pink-500 to-pink-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="fas fa-question-circle text-white text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-pink-600 transition-colors">What-Why-How</h3>
                <p className="text-gray-600 text-sm mb-4">Penjelasan APA yang dilakukan, MENGAPA penting, dan BAGAIMANA cara melaksanakannya</p>
                <div className="flex items-center text-pink-600 text-sm font-medium">
                  <span>Lihat Penjelasan</span>
                  <i className="fas fa-arrow-right ml-2 group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>

            {/* Keputusan Strategis */}
            <Link to="/strategic-decisions" className="group bg-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 overflow-hidden border border-gray-100">
              <div className="h-2 bg-gradient-to-r from-red-500 to-red-600"></div>
              <div className="p-6">
                <div className="w-12 h-12 bg-gradient-to-r from-red-500 to-red-600 rounded-lg flex items-center justify-center mb-4">
                  <i className="fas fa-chess text-white text-xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2 group-hover:text-red-600 transition-colors">Keputusan Strategis</h3>
                <p className="text-gray-600 text-sm mb-4">Analisis logika dan alasan di balik setiap keputusan strategis dengan mitigasi risiko</p>
                <div className="flex items-center text-red-600 text-sm font-medium">
                  <span>Lihat Keputusan</span>
                  <i className="fas fa-arrow-right ml-2 group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Timeline Preview */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Timeline Implementasi
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Proses transformasi digital yang terstruktur dari September 2025 hingga Juli 2026
            </p>
          </div>
          
          <div className="relative">
            <div className="absolute left-1/2 transform -translate-x-1/2 w-1 h-full bg-gradient-to-b from-blue-500 to-purple-600 rounded-full"></div>
            
            <div className="space-y-12">
              {[
                { month: 'Sep 2025', title: 'Kick-off & Sosialisasi', color: 'blue' },
                { month: 'Des 2025', title: 'Pilot Project', color: 'green' },
                { month: 'Mar 2026', title: 'Evaluasi & Optimasi', color: 'purple' },
                { month: 'Jul 2026', title: 'Full Implementation', color: 'orange' }
              ].map((item, index) => (
                <div key={index} className={`flex items-center ${index % 2 === 0 ? 'justify-start' : 'justify-end'}`}>
                  <div className={`w-5/12 ${index % 2 === 0 ? 'text-right pr-8' : 'text-left pl-8'}`}>
                    <div className="bg-white p-6 rounded-xl shadow-lg border-l-4 border-blue-500">
                      <h3 className="text-lg font-bold text-gray-800 mb-2">{item.title}</h3>
                      <p className="text-blue-600 font-semibold">{item.month}</p>
                    </div>
                  </div>
                  <div className="absolute left-1/2 transform -translate-x-1/2 w-4 h-4 bg-blue-500 rounded-full border-4 border-white shadow-lg"></div>
                </div>
              ))}
            </div>
          </div>
          
          <div className="text-center mt-12">
            <Link
              to="/timeline"
              className="bg-gradient-to-r from-blue-500 to-purple-600 text-white px-8 py-4 rounded-full font-semibold text-lg hover:from-blue-600 hover:to-purple-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
            >
              <i className="fas fa-arrow-right mr-2"></i>
              Lihat Timeline Lengkap
            </Link>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-blue-600 to-purple-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
            Siap Bergabung dalam Transformasi Digital?
          </h2>
          <p className="text-xl text-blue-100 mb-8 max-w-3xl mx-auto">
            Mari bersama-sama membangun masa depan pendidikan Islam yang modern dan terintegrasi
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/benefits"
              className="bg-white text-blue-600 px-8 py-4 rounded-full font-semibold text-lg hover:bg-blue-50 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
            >
              <i className="fas fa-star mr-2"></i>
              Lihat Manfaat
            </Link>
            <Link
              to="/mdm-explained"
              className="border-2 border-white text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-white hover:text-blue-600 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1"
            >
              <i className="fas fa-mobile-alt mr-2"></i>
              Pelajari MDM
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
